import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  tabindex: "-1",
  class: "modal-mask fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full"
}
const _hoisted_2 = { class: "modal-container relative w-full max-w-2xl max-h-full" }
const _hoisted_3 = { class: "relative bg-white shadow" }
const _hoisted_4 = { class: "flex items-center justify-between p-5 border-b rounded-t" }
const _hoisted_5 = { class: "text-xl font-semibold text-gray-900" }
const _hoisted_6 = { class: "p-6 space-y-6" }
const _hoisted_7 = { class: "flex items-center p-6 space-x-2 border-t border-gray-200 rounded-b" }




export default /*@__PURE__*/_defineComponent({
  __name: 'ModalBox',
  props: {
  show: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, [
            _renderSlot(_ctx.$slots, "header")
          ]),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
            type: "button",
            class: "text-gray-400 text-3xl bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
          }, " × ")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "main")
        ]),
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "footer")
        ])
      ])
    ])
  ]))
}
}

})